import { render, staticRenderFns } from "./EditPublishedPaper.vue?vue&type=template&id=529cc77f&scoped=true"
import script from "./EditPublishedPaper.vue?vue&type=script&lang=js"
export * from "./EditPublishedPaper.vue?vue&type=script&lang=js"
import style0 from "./EditPublishedPaper.vue?vue&type=style&index=0&id=529cc77f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529cc77f",
  null
  
)

export default component.exports